import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';

const C = { primary:'#2E7D32', primaryDark:'#1B5E20', border:'#E0E0E0', light:'#F4F6F9', green100:'#E8F5E9', textDark:'#212121', textMid:'#616161', textLight:'#9E9E9E' };

const ACTIONS = [
  { key: 'peut_lire', label: 'Lire', couleur: '#3498db', bg: '#ebf5fb' },
  { key: 'peut_ecrire', label: 'Écrire', couleur: '#27ae60', bg: '#eafaf1' },
  { key: 'peut_supprimer', label: 'Supprimer', couleur: '#e74c3c', bg: '#fdedec' },
  { key: 'peut_approuver', label: 'Approuver', couleur: '#f39c12', bg: '#fef9e7' },
];

const Toggle = ({ checked, onChange }) => (
  <div onClick={onChange} style={{
    width: 42, height: 24, borderRadius: 12, cursor: 'pointer', transition: 'all 0.2s',
    background: checked ? C.primary : '#ddd', position: 'relative', flexShrink: 0
  }}>
    <div style={{
      width: 18, height: 18, borderRadius: '50%', background: 'white',
      position: 'absolute', top: 3, transition: 'all 0.2s',
      left: checked ? 21 : 3, boxShadow: '0 1px 3px rgba(0,0,0,0.3)'
    }} />
  </div>
);

const FormRole = ({ role, modules, onSave, onCancel }) => {
  const estModif = !!role?.id;
  const [form, setForm] = useState({
    nom: role?.nom || '',
    libelle: role?.libelle || '',
    est_global: role?.est_global || false,
    description: role?.description || '',
    actif: role?.actif !== undefined ? role.actif : true,
  });
  const [permissions, setPermissions] = useState(() =>
    modules.map(m => {
      const ex = role?.permissions?.find(p => p.module_id === m.id);
      return { module_id: m.id, peut_lire: ex?.peut_lire||false, peut_ecrire: ex?.peut_ecrire||false, peut_supprimer: ex?.peut_supprimer||false, peut_approuver: ex?.peut_approuver||false };
    })
  );
  const [message, setMessage] = useState({ type: '', texte: '' });
  const [chargement, setChargement] = useState(false);

  const champ = (e) => setForm({ ...form, [e.target.name]: e.target.type === 'checkbox' ? e.target.checked : e.target.value });
  const togglePerm = (moduleId, action) => setPermissions(prev => prev.map(p => p.module_id === moduleId ? { ...p, [action]: !p[action] } : p));
  const toutAction = (action, val) => setPermissions(prev => prev.map(p => ({ ...p, [action]: val })));

  const soumettre = async (e) => {
    e.preventDefault();
    setChargement(true);
    try {
      if (estModif) await api.put(`/roles/${role.id}`, { ...form, permissions });
      else await api.post('/roles', { ...form, permissions });
      setMessage({ type: 'succes', texte: estModif ? '✅ Rôle modifié !' : '✅ Rôle créé !' });
      setTimeout(onSave, 900);
    } catch (err) {
      setMessage({ type: 'erreur', texte: err.response?.data?.message || 'Erreur serveur.' });
    } finally { setChargement(false); }
  };

  const totalPerms = permissions.reduce((acc, p) => acc + (p.peut_lire?1:0) + (p.peut_ecrire?1:0) + (p.peut_supprimer?1:0) + (p.peut_approuver?1:0), 0);

  return (
    <div style={{ position:'fixed',top:0,left:0,right:0,bottom:0,background:'rgba(0,0,0,0.6)',zIndex:1000,display:'flex',alignItems:'center',justifyContent:'center',padding:20 }}
      onClick={e => e.target===e.currentTarget && onCancel()}>
      <div style={{ background:'white',borderRadius:16,width:'100%',maxWidth:860,maxHeight:'92vh',overflowY:'auto',boxShadow:'0 20px 60px rgba(0,0,0,0.3)' }}>
        
        {/* Header modal */}
        <div style={{ background:C.primary,padding:'20px 28px',borderRadius:'16px 16px 0 0',display:'flex',justifyContent:'space-between',alignItems:'center' }}>
          <div>
            <div style={{ color:'white',fontSize:18,fontWeight:'bold' }}>{estModif ? '✏️ Modifier le rôle' : '➕ Nouveau rôle'}</div>
            {estModif && <div style={{ color:'rgba(255,255,255,0.8)',fontSize:13,marginTop:2 }}>{role.nom}</div>}
          </div>
          <button onClick={onCancel} style={{ background:'rgba(255,255,255,0.2)',border:'none',color:'white',width:32,height:32,borderRadius:'50%',cursor:'pointer',fontSize:16 }}>✕</button>
        </div>

        <div style={{ padding:28 }}>
          {message.texte && (
            <div style={{ padding:'12px 16px',borderRadius:8,marginBottom:20,background:message.type==='succes'?'#d4edda':'#f8d7da',color:message.type==='succes'?'#155724':'#721c24',fontWeight:'500' }}>
              {message.texte}
            </div>
          )}

          <form onSubmit={soumettre}>
            {/* Infos de base */}
            <div style={{ display:'grid',gridTemplateColumns:'1fr 1fr',gap:16,marginBottom:20 }}>
              <div>
                <label style={{ display:'block',fontSize:12,color:'#666',marginBottom:6,fontWeight:'600',textTransform:'uppercase',letterSpacing:'0.5px' }}>Nom technique *</label>
                <input style={{ width:'100%',padding:'10px 14px',border:'2px solid #e0e0e0',borderRadius:8,fontSize:14,boxSizing:'border-box',transition:'border-color 0.2s',outline:'none' }}
                  name="nom" value={form.nom} onChange={champ} placeholder="ex: responsable_stock" required disabled={estModif}
                  onFocus={e=>e.target.style.borderColor=C.primary} onBlur={e=>e.target.style.borderColor='#e0e0e0'} />
              </div>
              <div>
                <label style={{ display:'block',fontSize:12,color:'#666',marginBottom:6,fontWeight:'600',textTransform:'uppercase',letterSpacing:'0.5px' }}>Libellé affiché *</label>
                <input style={{ width:'100%',padding:'10px 14px',border:'2px solid #e0e0e0',borderRadius:8,fontSize:14,boxSizing:'border-box',outline:'none' }}
                  name="libelle" value={form.libelle} onChange={champ} placeholder="ex: Responsable Stock" required
                  onFocus={e=>e.target.style.borderColor=C.primary} onBlur={e=>e.target.style.borderColor='#e0e0e0'} />
              </div>
              <div style={{ gridColumn:'1/-1' }}>
                <label style={{ display:'block',fontSize:12,color:'#666',marginBottom:6,fontWeight:'600',textTransform:'uppercase',letterSpacing:'0.5px' }}>Description</label>
                <input style={{ width:'100%',padding:'10px 14px',border:'2px solid #e0e0e0',borderRadius:8,fontSize:14,boxSizing:'border-box',outline:'none' }}
                  name="description" value={form.description} onChange={champ} placeholder="Décrivez le rôle..."
                  onFocus={e=>e.target.style.borderColor=C.primary} onBlur={e=>e.target.style.borderColor='#e0e0e0'} />
              </div>
            </div>

            <div style={{ display:'flex',gap:24,marginBottom:24 }}>
              <label style={{ display:'flex',alignItems:'center',gap:10,cursor:'pointer' }}>
                <Toggle checked={form.est_global} onChange={()=>setForm({...form,est_global:!form.est_global})} />
                <span style={{ fontSize:14,color:'#333' }}>Rôle global <span style={{ color:'#888',fontSize:12 }}>(non lié à un abattoir)</span></span>
              </label>
              {estModif && (
                <label style={{ display:'flex',alignItems:'center',gap:10,cursor:'pointer' }}>
                  <Toggle checked={form.actif} onChange={()=>setForm({...form,actif:!form.actif})} />
                  <span style={{ fontSize:14,color:'#333' }}>Rôle actif</span>
                </label>
              )}
            </div>

            {/* Matrice permissions */}
            <div style={{ background:'#f8f9fa',borderRadius:12,padding:20,marginBottom:20 }}>
              <div style={{ display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:16 }}>
                <div style={{ fontSize:15,fontWeight:'bold',color:C.primary }}>🔐 Permissions par module</div>
                <div style={{ fontSize:13,color:'#888' }}>{totalPerms} permission(s) accordée(s)</div>
              </div>

              {/* Raccourcis globaux */}
              <div style={{ display:'flex',gap:8,flexWrap:'wrap',marginBottom:16,paddingBottom:16,borderBottom:'1px solid #e0e0e0' }}>
                <span style={{ fontSize:12,color:'#888',alignSelf:'center',marginRight:4 }}>Tout cocher :</span>
                {ACTIONS.map(a => (
                  <div key={a.key} style={{ display:'flex',gap:4,alignItems:'center' }}>
                    <button type="button" onClick={() => toutAction(a.key, true)}
                      style={{ fontSize:11,padding:'4px 10px',background:a.bg,border:`1px solid ${a.couleur}`,borderRadius:20,cursor:'pointer',color:a.couleur,fontWeight:'bold' }}>
                      ✓ {a.label}
                    </button>
                    <button type="button" onClick={() => toutAction(a.key, false)}
                      style={{ fontSize:11,padding:'4px 8px',background:'#f8d7da',border:'1px solid #e74c3c',borderRadius:20,cursor:'pointer',color:'#e74c3c',fontWeight:'bold' }}>
                      ✕
                    </button>
                  </div>
                ))}
              </div>

              {/* Lignes modules */}
              {modules.map((m, idx) => {
                const perm = permissions.find(p => p.module_id === m.id) || {};
                const nbPerm = ACTIONS.filter(a => perm[a.key]).length;
                return (
                  <div key={m.id} style={{ display:'flex',alignItems:'center',padding:'12px 14px',borderRadius:8,marginBottom:6,background:idx%2===0?'white':'#f8f9fa',border:'1px solid #e8e8e8' }}>
                    <div style={{ flex:1,fontWeight:'500',fontSize:14,color:'#333' }}>{m.libelle}</div>
                    <div style={{ display:'flex',gap:20,alignItems:'center' }}>
                      {ACTIONS.map(a => (
                        <label key={a.key} onClick={() => togglePerm(m.id, a.key)}
                          style={{ display:'flex',flexDirection:'column',alignItems:'center',gap:4,cursor:'pointer',minWidth:60 }}>
                          <div style={{ width:28,height:28,borderRadius:6,border:`2px solid ${perm[a.key]?a.couleur:'#ddd'}`,
                            background:perm[a.key]?a.bg:'white',display:'flex',alignItems:'center',justifyContent:'center',transition:'all 0.15s' }}>
                            {perm[a.key] && <span style={{ color:a.couleur,fontWeight:'bold',fontSize:14 }}>✓</span>}
                          </div>
                          <span style={{ fontSize:10,color:perm[a.key]?a.couleur:'#aaa',fontWeight:'600' }}>{a.label}</span>
                        </label>
                      ))}
                    </div>
                    <div style={{ marginLeft:16,width:24,height:24,borderRadius:'50%',background:nbPerm>0?C.primary:'#eee',display:'flex',alignItems:'center',justifyContent:'center' }}>
                      <span style={{ color:nbPerm>0?'white':'#aaa',fontSize:10,fontWeight:'bold' }}>{nbPerm}</span>
                    </div>
                  </div>
                );
              })}
            </div>

            <div style={{ display:'flex',gap:12,justifyContent:'flex-end' }}>
              <button type="button" onClick={onCancel}
                style={{ padding:'11px 24px',borderRadius:8,border:'2px solid #ddd',background:'white',fontSize:14,cursor:'pointer',color:'#555',fontWeight:'500' }}>
                Annuler
              </button>
              <button type="submit" disabled={chargement}
                style={{ padding:'11px 28px',borderRadius:8,border:'none',background:C.primary,color:'white',fontSize:14,cursor:'pointer',fontWeight:'bold' }}>
                {chargement ? '⏳ Enregistrement...' : estModif ? '💾 Sauvegarder' : '✅ Créer le rôle'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default function GestionRolesPage() {
  const navigate = useNavigate();
  const [roles, setRoles] = useState([]);
  const [modules, setModules] = useState([]);
  const [message, setMessage] = useState({ type:'', texte:'' });
  const [afficherForm, setAfficherForm] = useState(false);
  const [roleEdit, setRoleEdit] = useState(null);
  const [recherche, setRecherche] = useState('');
  const [chargement, setChargement] = useState(true);

  const charger = async () => {
    setChargement(true);
    try {
      const [r1, r2] = await Promise.all([api.get('/roles'), api.get('/roles/modules')]);
      setRoles(r1.data);
      setModules(r2.data);
    } catch { setMessage({ type:'erreur', texte:'Erreur chargement.' }); }
    finally { setChargement(false); }
  };

  useEffect(() => { charger(); }, []);

  const supprimer = async (id, libelle) => {
    if (!window.confirm(`Supprimer le rôle "${libelle}" ?`)) return;
    try {
      await api.delete(`/roles/${id}`);
      setMessage({ type:'succes', texte:'✅ Rôle supprimé.' });
      charger();
    } catch (e) { setMessage({ type:'erreur', texte: e.response?.data?.message || 'Erreur.' }); }
  };

  const filtres = roles.filter(r =>
    r.nom.toLowerCase().includes(recherche.toLowerCase()) ||
    r.libelle.toLowerCase().includes(recherche.toLowerCase())
  );

  const stats = { total: roles.length, globaux: roles.filter(r=>r.est_global).length, actifs: roles.filter(r=>r.actif).length };

  return (
    <div style={{ minHeight:'100vh', background: C.light }}>
      {/* Topbar */}
      <div style={{ height:52, background:'#fff', borderBottom:`1px solid ${C.border}`, display:'flex', alignItems:'center', justifyContent:'space-between', padding:'0 24px', position:'sticky', top:0, zIndex:100 }}>
        <div style={{ fontSize:13, color: C.textLight, display:'flex', alignItems:'center', gap:6 }}>
          <span>Administration</span>
          <span style={{ color: C.border }}>›</span>
          <span style={{ color: C.textDark, fontWeight:600 }}>Gestion des rôles</span>
        </div>
        <button onClick={() => navigate('/users')} style={{ background:'transparent', border:'none', color: C.textMid, fontSize:13, cursor:'pointer' }}>
          ← Utilisateurs
        </button>
      </div>

      <div style={{ maxWidth:1300, margin:'20px auto', padding:'0 20px', paddingBottom:40 }}>
        {/* Stats */}
        <div style={{ display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:14,marginBottom:18 }}>
          {[
            { label:'Total des rôles', val:stats.total, couleur: C.primary, bg: C.green100, icon:'🔐' },
            { label:'Rôles globaux', val:stats.globaux, couleur:'#1565C0', bg:'#E3F2FD', icon:'🌐' },
            { label:'Rôles actifs', val:stats.actifs, couleur: C.primaryDark, bg: C.green100, icon:'✅' },
          ].map((s,i) => (
            <div key={i} style={{ background:'white', borderRadius:10, padding:'14px 18px', border:`0.5px solid ${C.border}`, boxShadow:'0 1px 3px rgba(0,0,0,.06)', display:'flex', alignItems:'center', gap:14 }}>
              <div style={{ width:42, height:42, background:s.bg, borderRadius:10, display:'flex', alignItems:'center', justifyContent:'center', fontSize:20 }}>{s.icon}</div>
              <div>
                <div style={{ fontSize:24, fontWeight:'bold', color:s.couleur }}>{s.val}</div>
                <div style={{ fontSize:11, color: C.textLight }}>{s.label}</div>
              </div>
            </div>
          ))}
        </div>

        {message.texte && (
          <div style={{ padding:'12px 16px', borderRadius:8, marginBottom:16, background:message.type==='succes'? C.green100:'#FFEBEE', color:message.type==='succes'? C.primaryDark:'#C62828', border:`1px solid ${message.type==='succes'?'#A5D6A7':'#EF9A9A'}`, fontWeight:500, display:'flex', justifyContent:'space-between', alignItems:'center' }}>
            {message.texte}
            <button onClick={()=>setMessage({type:'',texte:''})} style={{ background:'none',border:'none',cursor:'pointer',fontSize:16,color:'inherit' }}>✕</button>
          </div>
        )}

        {/* Barre recherche + bouton */}
        <div style={{ display:'flex',gap:12,marginBottom:20,alignItems:'center' }}>
          <div style={{ flex:1,position:'relative' }}>
            <span style={{ position:'absolute',left:12,top:'50%',transform:'translateY(-50%)',color:'#aaa',fontSize:16 }}>🔍</span>
            <input value={recherche} onChange={e=>setRecherche(e.target.value)}
              placeholder="Rechercher un rôle..."
              style={{ width:'100%',padding:'9px 14px 9px 40px',border:`1px solid ${C.border}`,borderRadius:8,fontSize:13,boxSizing:'border-box',outline:'none',background:'white' }}
              onFocus={e=>e.target.style.borderColor=C.primary} onBlur={e=>e.target.style.borderColor=C.border} />
          </div>
          <button onClick={() => { setRoleEdit(null); setAfficherForm(true); }}
            style={{ padding:'9px 18px',background:C.primary,color:'white',border:'none',borderRadius:8,fontSize:13,fontWeight:700,cursor:'pointer',display:'flex',alignItems:'center',gap:8,whiteSpace:'nowrap' }}>
            ➕ Nouveau rôle
          </button>
        </div>

        {/* Grille de cartes */}
        {chargement ? (
          <div style={{ textAlign:'center',padding:60,color:'#888',fontSize:16 }}>⏳ Chargement...</div>
        ) : (
          <div style={{ display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(340px,1fr))',gap:18 }}>
            {filtres.map(r => {
              const totalPerms = (r.permissions||[]).reduce((acc,p) => acc+(p.peut_lire?1:0)+(p.peut_ecrire?1:0)+(p.peut_supprimer?1:0)+(p.peut_approuver?1:0), 0);
              const modulesAvecAcces = (r.permissions||[]).filter(p => p.peut_lire||p.peut_ecrire||p.peut_supprimer||p.peut_approuver).length;
              const protege = ['super_admin','admin'].includes(r.nom);
              return (
                <div key={r.id} style={{ background:'white',borderRadius:12,border:`0.5px solid ${C.border}`,boxShadow:'0 1px 3px rgba(0,0,0,0.06)',overflow:'hidden',opacity:r.actif?1:0.75,transition:'box-shadow 0.2s' }}
                  onMouseEnter={e=>e.currentTarget.style.boxShadow='0 4px 12px rgba(0,0,0,0.12)'}
                  onMouseLeave={e=>e.currentTarget.style.boxShadow='0 1px 3px rgba(0,0,0,0.06)'}>
                  
                  {/* Card header */}
                  <div style={{ background: r.actif ? C.primary : '#9E9E9E',padding:'16px 18px',display:'flex',justifyContent:'space-between',alignItems:'flex-start' }}>
                    <div>
                      <div style={{ color:'white',fontWeight:'bold',fontSize:16 }}>{r.libelle}</div>
                      <div style={{ color:'rgba(255,255,255,0.75)',fontSize:12,fontFamily:'monospace',marginTop:3 }}>{r.nom}</div>
                    </div>
                    <div style={{ display:'flex',flexDirection:'column',alignItems:'flex-end',gap:6 }}>
                      <span style={{ background:'rgba(255,255,255,0.25)',color:'white',padding:'3px 10px',borderRadius:20,fontSize:11,fontWeight:'bold' }}>
                        {r.est_global ? '🌐 Global' : '🏭 Abattoir'}
                      </span>
                      {!r.actif && <span style={{ background:'rgba(0,0,0,0.2)',color:'white',padding:'2px 8px',borderRadius:20,fontSize:10 }}>Inactif</span>}
                      {protege && <span style={{ background:'rgba(255,255,255,0.2)',color:'white',padding:'2px 8px',borderRadius:20,fontSize:10 }}>🔒 Protégé</span>}
                    </div>
                  </div>

                  <div style={{ padding:'16px 18px' }}>
                    {r.description && <div style={{ fontSize:13,color:'#777',marginBottom:12,fontStyle:'italic' }}>{r.description}</div>}

                    {/* Stats permissions */}
                    <div style={{ display:'flex',gap:8,marginBottom:14 }}>
                      <div style={{ flex:1,textAlign:'center',padding:'8px 4px',background:'#f8f9fa',borderRadius:8 }}>
                        <div style={{ fontSize:18,fontWeight:'bold',color:C.primary }}>{modulesAvecAcces}</div>
                        <div style={{ fontSize:10,color:'#888' }}>modules</div>
                      </div>
                      <div style={{ flex:1,textAlign:'center',padding:'8px 4px',background:'#f8f9fa',borderRadius:8 }}>
                        <div style={{ fontSize:18,fontWeight:'bold',color:'#2980b9' }}>{totalPerms}</div>
                        <div style={{ fontSize:10,color:'#888' }}>permissions</div>
                      </div>
                      {ACTIONS.map(a => {
                        const cnt = (r.permissions||[]).filter(p=>p[a.key]).length;
                        return cnt > 0 ? (
                          <div key={a.key} style={{ flex:1,textAlign:'center',padding:'8px 4px',background:a.bg,borderRadius:8 }}>
                            <div style={{ fontSize:18,fontWeight:'bold',color:a.couleur }}>{cnt}</div>
                            <div style={{ fontSize:10,color:a.couleur,fontWeight:'600' }}>{a.label.slice(0,4)}</div>
                          </div>
                        ) : null;
                      })}
                    </div>

                    {/* Modules avec accès */}
                    {(r.permissions||[]).filter(p=>p.peut_lire||p.peut_ecrire||p.peut_supprimer||p.peut_approuver).length > 0 && (
                      <div style={{ display:'flex',flexWrap:'wrap',gap:5,marginBottom:14 }}>
                        {(r.permissions||[]).filter(p=>p.peut_lire||p.peut_ecrire||p.peut_supprimer||p.peut_approuver).map(p => (
                          <span key={p.module_id} style={{ fontSize:11,padding:'3px 8px',background: C.green100,color: C.primaryDark,borderRadius:20,border:'1px solid #A5D6A7',fontWeight:500 }}>
                            {p.module_libelle}
                          </span>
                        ))}
                      </div>
                    )}

                    {/* Actions */}
                    <div style={{ display:'flex',gap:8,paddingTop:12,borderTop:'1px solid #f0f0f0' }}>
                      <button onClick={() => { setRoleEdit(r); setAfficherForm(true); }}
                        style={{ flex:1,padding:'7px',background:C.primary,color:'white',border:'none',borderRadius:7,cursor:'pointer',fontSize:12,fontWeight:600 }}>
                        ✏️ Modifier
                      </button>
                      {!protege && (
                        <button onClick={() => supprimer(r.id, r.libelle)}
                          style={{ padding:'8px 14px',background:'#fdf2f2',color:'#e74c3c',border:'1px solid #fadbd8',borderRadius:8,cursor:'pointer',fontSize:13,fontWeight:'500' }}>
                          🗑️
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>

      {afficherForm && (
        <FormRole role={roleEdit} modules={modules}
          onSave={() => { setAfficherForm(false); setRoleEdit(null); charger(); }}
          onCancel={() => { setAfficherForm(false); setRoleEdit(null); }} />
      )}
    </div>
  );
}
